import { defineCollectionStore } from '@/utils/defineCollectionStore';

export const usePartnersStore = defineCollectionStore({
	id: 'partners',
	endpoint: '/api/partners',
	dataKey: 'data',
	wrapRecords: true,
	errorLabel: 'Fetch Partners Error: ',
	fetchName: 'fetchPartners',
	archive: {
		toggleName: 'toggleArchivedPartners',
		archivedDataKey: 'archivedData',
		archivedFetchName: 'fetchArchivedPartners',
		// Verbatim quirk: hardcoded to the 2023 archive regardless of `year`.
		archivedEndpoint: () => '/api/archive/2023/partners',
		getters: {
			partnersData: 'data',
		},
	},
});
